import PropTypes from "prop-types";
import React, { useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { useEffect } from "react";

const ShopTag = ({ tags, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [tagSelected, setTagSelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.tag?.split("|")
  );
  const [refresh, setRefresh] = useState(true);
  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };
  useEffect(() => {
    setTagSelected(
      JSON.parse(sessionStorage.getItem("filter"))?.tag?.split("|")
    );
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);
  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Tags
      </div>
      {/*<div className="shopping-cart-btn btn-hover text-center" style={{ padding: "10px" }}>
        <a style={{ padding: "10px", border: "1px gray solid", display: "block", width: "100%" }} onClick={() => CambioStato()}  >Tag</a>
      </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}

      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag ">
          {tags ? (
            <ul>
              {tags.map((tag, key) => {
                if (tag == "") return;
                return (
                  <li key={key}>
                    <button
                      className={
                        tagSelected?.find((v) => tag === v) ? "active" : ""
                      }
                      onClick={(e) => {
                        if (e.currentTarget.classList.contains("active"))
                          getSortParams("tag", tag, "-");
                        else getSortParams("tag", tag, "+");
                        //getSortParams("tag", tag, "+");
                        setActiveSort(e);
                      }}
                    >
                      {tag}
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

ShopTag.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
};

export default ShopTag;
